module.exports = __webpack_public_path__ + "img/amigo.8758b028.png";